import {ActivatedRouteSnapshot, CanActivateFn} from "@angular/router";
import {inject} from "@angular/core";
import {RouteService} from "@core/services/route.service";
import {AlertService} from "@core/services/alert.service";
import {PermissionService} from "@core/services/permission.service";

export const PermissionGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    if (!route.data['profiles']) {
        throw new Error('PermissionGuard: Profiles are required to be set on route data.');
    }

    const alertService = inject(AlertService);
    const routeService = inject(RouteService);
    const permissionService = inject(PermissionService);
    const profiles = route.data['profiles'] as Array<string>;
    const profileOperator: 'OR' | 'AND' = route.data['profilesOperator'] || 'OR';

    if (profiles && profiles.length === 0) {
        return true;
    }

    // Usa os métodos otimizados com computed signals
    let hasAccess: boolean;

    if (profiles.length === 1) {
        // Um perfil → usa canAccess
        hasAccess = permissionService.canAccess(profiles[0])();
    } else if (profileOperator === 'OR') {
        // Múltiplos perfis OR → usa canAccessAny
        hasAccess = permissionService.canAccessAny(profiles)();
    } else {
        // Múltiplos perfis AND → usa canAccessAll
        hasAccess = permissionService.canAccessAll(profiles)();
    }

    if (hasAccess) {
        return true;
    }

    alertService.warning('Você não tem privilégios de acesso para realizar esta ação.', 'Se tiver dúvidas, entre em contato com o administrador.');
    routeService.go(['/dashboard']);
    return false;
};
